import type { SVGProps } from 'react';

const SvgArrowSmallN = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m15.71 9.29-3-3a.996.996 0 0 0-1.41 0l-3 3a.996.996 0 1 0 1.41 1.41L11 9.41V17c0 .55.45 1 1 1s1-.45 1-1V9.41l1.29 1.29c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41"
    />
  </svg>
);
export default SvgArrowSmallN;
